import { useState, useEffect } from 'react';
import { Monitor, X } from 'lucide-react';

const MOBILE_BREAKPOINT = 768; // px

export default function MobileAlert() {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      const isMobile = window.innerWidth < MOBILE_BREAKPOINT;
      setIsVisible(isMobile && !isDismissed);
    };

    // Check on mount
    checkScreenSize();

    // Check on resize
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, [isDismissed]);

  const handleDismiss = () => {
    setIsDismissed(true);
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-[9999] bg-black/50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-sm w-full p-6 relative">
        {/* Icon */}
        <div className="flex justify-center mb-4">
          <div className="p-4 rounded-full bg-primary/10">
            <Monitor className="w-10 h-10 text-primary" />
          </div>
        </div>

        {/* Content */}
        <div className="text-center mb-6">
          <h2 className="text-xl font-bold text-text-primary mb-2">
            Best on Larger Screens
          </h2>
          <p className="text-text-secondary text-sm leading-relaxed">
            The Admin Panel is optimized for desktop, laptop, or tablet screens.
            For the best experience, please use a device with a larger screen.
          </p>
        </div>

        {/* Actions */}
        <div>
          <button
            onClick={handleDismiss}
            className="w-full py-3 px-4 bg-primary text-white font-medium rounded-xl hover:bg-primary/90 transition-colors"
          >
            Continue Anyway
          </button>
        </div>

        {/* Close button */}
        <button
          onClick={handleDismiss}
          className="absolute top-4 right-4 p-2 text-text-muted hover:text-text-primary transition-colors"
          aria-label="Close"
        >
          <X className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
}
